import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';

import "./css/style.css";
import "./css/slick.css";
import "./css/slick-theme.css";

class About extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentSlide: 0
        }
    }

    renderSlide() {
        switch (this.state.currentSlide) {
            case 0:
                return (
                    <div>
                        <div className="logoImage"></div>
                        <div className="slider-entry">
                            <div className="caption">
                                <h2>Thank you for your purchase</h2>
                                <p>We know you're going to make someone's day!</p>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div className="slider-entry" style={{ textAlign: 'center' }}>
                        <div className="">
                            <h2>SCAN</h2>
                            <p>The Say More Code located on the inside of your greeting card can be scanned with most smartphone cameras, or download and free QR cdoe scann app from your App Store.</p>
                        </div>
                        <img src={require("./img/scan.png")} alt='' style={{ maxHeight: "100%", maxWidth: "100%", width: 'auto', height: 'auto' }} />
                    </div>
                );
            case 2:
                return (
                    <div className="slider-entry">
                        <div className="caption">
                            <h2>VIDEO</h2>
                            <p>We'll put a video here</p>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }
    renderSlider() {
        switch (this.state.currentSlide) {
            case 0:
                return (
                    <div style={{ width: '100%', height: '20px', margin: '0 auto', textAlign: 'center' }}>
                        <span className='slideSelector buttonBackgroundColor' onClick={() => this.setState({ currentSlide: 0 })}></span><span className='slideSelector' onClick={() => this.setState({ currentSlide: 1 })}></span><span className='slideSelector' onClick={() => this.setState({ currentSlide: 2 })}></span>
                    </div>
                );
            case 1:
                return (
                    <div style={{ width: '100%', height: '20px', margin: '0 auto', textAlign: 'center' }}>
                        <span className='slideSelector' onClick={() => this.setState({ currentSlide: 0 })}></span><span className='slideSelector buttonBackgroundColor' onClick={() => this.setState({ currentSlide: 1 })}></span><span className='slideSelector' onClick={() => this.setState({ currentSlide: 2 })}></span>
                    </div>
                );
            case 2:
                return (
                    <div style={{ width: '100%', height: '20px', margin: '0 auto', textAlign: 'center' }}>
                        <span className='slideSelector' onClick={() => this.setState({ currentSlide: 0 })}></span><span className='slideSelector' onClick={() => this.setState({ currentSlide: 1 })}></span><span className='slideSelector buttonBackgroundColor' onClick={() => this.setState({ currentSlide: 2 })}></span>
                    </div>
                );
            default:
                return null;
        }
    }
    render() {
        var settings = {
            dots: true,
            ininite: true,
            speed: 1000,
            sliderToShow: 1,
            sliderToScroll: 1,
            arrows: false,
            adaptiveHeight: false,
            autoplay: false
        };
        return (
            <div>
                <div className="walkthrough">
                    <div className="container">
                        <div className="entry">
                            <div className="logoImage"></div>
                            <Slider {...settings}>
                                {/* <div>
                                <h4>Thank you for your purchase</h4>
                                <p>We know you're going to make someone's day!</p>
                            </div> */}
                                <div>
                                    <img src={require("./img/Scan@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto' }} />
                                    <h5>SCAN</h5>
                                    <p>The Say More Code located on the inside of your greeting card can be scanned with most smartphone cameras, or download and free QR code scan app from your App Store.</p>
                                </div>
                                <div>
                                    <img src={require("./img/Upload@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto' }} />
                                    <h5>UPLOAD</h5>
                                    <p>After scanning, you will be directed to your device storage, where you can choose the video you'd like to include on your card. After upload, you can simply scan your code again, but this time you'll see your video.</p>
                                </div>
                                <div>
                                    <img src={require("./img/Send@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto' }} />
                                    <h5>SEND</h5>
                                    <p>That's it! Your card is now ready to give away. We know you'll find the process simeple and fun. And your loved one is going to love it.</p>
                                </div>
                            </Slider>

                            {/* <Link to="account" className="button">GET STARTED</Link> */}
                            <a className="button" onClick={this.props.history.goBack}>GET STARTED</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(About);


// WEBPACK FOOTER //
// ./src/components/About.js